<template>
	<dt>
		<sb-rich-text :document="blok.question" />
	</dt>

	<dd>
		<sb-rich-text :document="blok.answer" />
	</dd>
</template>

<script setup lang="ts">
import type {BlokComponent} from "@pkg/shared/types";

defineProps<{
	blok: Extract<BlokComponent, {component: "sb-faq-item"}>;
	id?: string | number;
	name?: string | null;
	creative?: string | null;
	page?: string;
	type?: string;
}>();
</script>
